define('modules/htmlad/form/ean_code_form/htmlad_form_ean_code_form_view',[
  'backbone',
  'jquery',
  '_',
  'Quagga', 

  'modules/form/form_item_model',
  'modules/form/checkbox_view',
  'modules/form/input_view',
  'modules/button/button_view',

  './htmlad_form_ean_code_form_model',
  'text!./htmlad_form_ean_code_form_template.html'
], function (Backbone, $, _, Quagga,
             FormItemModel,
             CheckboxView,
             InputView,
             ButtonView,
             EanCodeModel,
             ean_code_template) {
  'use strict';
  var View = Backbone.View.extend({
      initialize: function (opts) {
        _.extend(this, opts);

        this.model = new EanCodeModel({
          content: this.content,
          price: this.price,
          ean_code: this.ean_code,
          form_cleared: false
        });

        this.dataModel = new Backbone.Model();

        this.checkboxName = _.uniqueId('ean-code-action-');

        this.render();
      },

      events: {
        'input  #input_id-ean-code': 'fieldsChanged',
        'keydown #input_id-ean-code': 'keyDown',
        'change .input-checkbox': 'fieldsChanged',
        'click .js-ean-code-form-clear-button': 'clearFormAndSubmit',
        'click #ean-scanner': 'closeScanner'
      },

      subViews: [],
      template: _.template(ean_code_template),
      className: 'EanCodeForm',

      render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        var checkbox = new CheckboxView({
          model: new FormItemModel({
            'name': this.checkboxName,
            'type': 'checkbox',
            'options': [
              {
                'label': _.t('htmlad_ean_code_form.check.content'),
                'value': '1',
                'state': this.model.get('content') ? 'active' : ''
              },
              {
                'label': _.t('htmlad_ean_code_form.check.price'),
                'value': '2',
                'state': this.model.get('price') ? 'active' : ''
              }
            ]
          }), dataModel: this.dataModel
        });
        this.$el.append(checkbox.$el);
        this.subViews.push(checkbox);

        var input = new InputView({
          model: new FormItemModel({
            'name': 'ean-code',
            'type': 'text',
            'placeholder': _.t('htmlad_ean_code_form.input.placeholder'),
            'input_readonly': true,
            'value': this.model.get('ean_code')
          }), dataModel: this.dataModel
        });
        this.$el.append(input.$el);
        this.subViews.push(input);

        var hasContentInfo = this.model.get('content') || this.model.get('price');
        var chooseButton = new ButtonView({
          label: 'htmlad_ean_code_form.button.choose',
          className: 'button js-ean-code-form-button EanCodeForm-ean-code readonly ' + ((hasContentInfo) ? 'is-hidden' : ''),
          href: '#'
        });
        this.$el.append(chooseButton.$el);
        this.subViews.push(chooseButton);

        if (hasContentInfo) {
          var clearButton = new ButtonView({
            label: 'htmlad_ean_code_form.button.clear',
            className: 'button js-ean-code-form-clear-button EanCodeForm-ean-code',
            href: '#'
          });
          this.$el.append(clearButton.$el);
          this.subViews.push(clearButton);
        }

        var scanButton = new ButtonView({
          label_text: 'scan barcode',
          icon: 'barcode',
          className: 'button js-ean-code-form-scan-button hide-for-desktop EanCodeForm-ean-code readonly',
          href: '#'
        });
        this.$el.append(scanButton.$el);
        this.subViews.push(scanButton);

        return this;
      },

      keyDown: function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          this.$('#input_id-ean-code').trigger('change');
          this.save();
        }
      },

      fieldsChanged: function () {
        var eanCodeAction = $('input:checkbox:checked').map(function () {
          return this.value;
        }).get();
        this.$('#input_id-ean-code').prop('readonly', eanCodeAction.length < 3);
        if (eanCodeAction.length < 3) {
          this.$('.js-ean-code-form-scan-button').addClass('readonly');
          $(this.el).off('click', '.js-ean-code-form-scan-button');
        } else {
          this.$('.js-ean-code-form-scan-button').removeClass('readonly');
          this.delegateEvents(_.extend(this.events, {'click .js-ean-code-form-scan-button': 'scanEAN'}));        
        }

        var eanCode = this.$('#input_id-ean-code').val() || '';

        if (eanCode.length > 0 && eanCodeAction.length > 0) {
          this.$('.js-ean-code-form-button').removeClass('readonly');
          this.delegateEvents(_.extend(this.events, {'click .js-ean-code-form-button': 'save'}));
        } else {
          this.$('.js-ean-code-form-button').addClass('readonly');
          $(this.el).off('click', '.js-ean-code-form-button');
        }
      },

      save: function () {
        var eanCodeAction = this.dataModel.get(this.checkboxName) || [];
        this.model.set({
          'content': eanCodeAction.indexOf('1') > -1,
          'price': eanCodeAction.indexOf('2') > -1,
          'ean_code': this.dataModel.get('ean-code') || ''
        }, {silent: true});
        this.model.trigger('change', this.model);
      },

      clearFormAndSubmit: function () {

        console.log('clearFormAndSubmit');

        this.model.set({
          'content': false,
          'price': false,
          'ean_code': '',
          'form_cleared': true
        }, {silent: true});
        this.model.trigger('change', this.model);


        _.each(this.subViews, function (view) {
          if (view && view.remove) {
            view.remove();
          }
        });

        this.render();
      },

      scanEAN: function () {
        var that = this;
        that.state.inputStream.target = document.querySelector('#ean-scanner');
        this.$('.ean-scanner-loading').removeClass('is-hidden');
        this.$('#ean-scanner').removeClass('is-hidden');
        this.$('.ean-scanner-settings').removeClass('is-hidden');
        $('body').addClass('camera-active');
        window.Quagga.init(that.state, function(err) {
            if (err) {
                console.log(err.message);
                if (err.message == 'Could not start video source') {
                  console.log('Reseting input stream');
                  that.devicesChecked.push(that.state.inputStream.constraints.deviceId);
                  that.state.inputStream = {
                      name : 'Live',
                      type : 'LiveStream',
                      constraints: {
                          width: {min: 640},
                          height: {min: 480},
                          aspectRatio: {min: 1, max: 100},
                          facingMode: 'environment'
                      },
                      target: document.querySelector('#ean-scanner')
                  };
                  that.detachListeners();
                  that.scanEAN();
                }
                return;
            }
            window.Quagga.onDetected(function (data) {
              console.log(data);
              that.$('#input_id-ean-code').val(data.codeResult.code);
              if (data.codeResult.code.length > 0) {
                that.$('.js-ean-code-form-button').removeClass('readonly');
                that.delegateEvents(_.extend(that.events, {'click .js-ean-code-form-button': 'save'}));
              }
              that.closeScanner();
            });
            that.attachListeners();
            that.checkCapabilities();
            window.Quagga.start();
        });
      },

      checkCapabilities: function() {
        var track = window.Quagga.CameraAccess.getActiveTrack();
        var capabilities = {};
        if (typeof track.getCapabilities === 'function') {
            capabilities = track.getCapabilities();
        }
        if ( (!capabilities.focusMode || !~capabilities.focusMode.indexOf('continuous') || ~capabilities.facingMode.indexOf('user')) && !~this.devicesChecked.indexOf(capabilities.deviceId)) {
          this.devicesChecked.push(capabilities.deviceId);
          this.swapToNextCamera();
          return;
        }
        this.$('.ean-scanner-loading').addClass('is-hidden');
        this.applySettingsVisibility('zoom', capabilities.zoom);
        this.applySettingsVisibility('torch', capabilities.torch);
        this.applySettingsVisibility('focus', capabilities.focusMode, capabilities.focusDistance);
      },

      applySettingsVisibility: function(setting, capability, extrainfo) {
          var track = window.Quagga.CameraAccess.getActiveTrack();
          var node;
          if (setting == 'torch') {
              node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                  node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
          }
          if (setting === 'zoom') {
            node = document.querySelector('input[name="settings_' + setting + '"]');
            if (typeof capability === 'object') {
              if (node) {
                  this.updateOptionsForMediaRange(node, capability);
                  node.parentNode.style.display = 'block';
              }
            } else {
              if (node) {
                node.parentNode.style.display = 'none';
              }
            }
            return;
          }
          if (setting === 'focus') {
            if (capability && ~capability.indexOf('continuous')) {
              track.applyConstraints({advanced : [{focusMode: 'continuous'}]});
            } else if (extrainfo) {
              node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                  this.updateOptionsForMediaRange(node, extrainfo);
                  node.parentNode.style.display = 'block';
              }
              return;
            }
          }
      },

      updateOptionsForMediaRange: function(node, range) {
        node.setAttribute('min', range.min);
        node.setAttribute('max', range.max);
        node.setAttribute('step', range.step);
        node.setAttribute('value', 0);
      },

      attachListeners: function() {
        var self = this;

        self.initCameraSelection();

        $('.ean-controls').on('change', 'input, select', function(e) {
            e.preventDefault();
            var $target = $(e.target),
                value = $target.attr('type') === 'checkbox' ? $target.prop('checked') : $target.val(),
                name = $target.attr('name'),
                state = self._convertNameToState(name);

            console.log('Value of '+ state + ' changed to ' + value);
            self.setState(state, value);
        });
      },

      swapToNextCamera: function() {
        var self = this;
        return window.Quagga.CameraAccess.enumerateVideoDevices()
        .then(function(devices) {
          devices.forEach(function(device) {
            if (!~self.devicesChecked.indexOf(device.deviceId)) {
              self.state.inputStream.constraints.deviceId = device.deviceId;
              self.detachListeners();
              window.Quagga.CameraAccess.getActiveTrack().stop();
              window.Quagga.stop();
              self.scanEAN();
              return;
            }
          });
        });
      },

      turnOffCameraStream: function() {
        window.Quagga.CameraAccess.getActiveTrack().stop();
        //window.Quagga.CameraAccess.release();
      },

      initCameraSelection: function(){
        var streamLabel = window.Quagga.CameraAccess.getActiveStreamLabel();

        return window.Quagga.CameraAccess.enumerateVideoDevices()
        .then(function(devices) {
            function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
            }
            var $deviceSelection = document.getElementById('deviceSelection');
            while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
            }
            devices.forEach(function(device) {
                var $option = document.createElement('option');
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
            });
        });
      },

      setState: function(path, value) {
        var self = this;

        if (typeof self._accessByPath(self.inputMapper, path) === 'function') {
            value = self._accessByPath(self.inputMapper, path)(value);
        }

        if (path.startsWith('settings.')) {
            var setting = path.substring(9);
            return self.applySetting(setting, value);
        }
        self._accessByPath(self.state, path, value);

        // console.log(JSON.stringify(self.state));
        self.detachListeners();
        window.Quagga.stop();
        self.scanEAN();
      },

      detachListeners: function() {
        $('.ean-controls').off('change', 'input, select');
      },

      _accessByPath: function(obj, path, val) {
        var parts = path.split('.'),
            depth = parts.length,
            setter = (typeof val !== 'undefined') ? true : false;

        return parts.reduce(function(o, key, i) {
            if (setter && (i + 1) === depth) {
                if (typeof o[key] === 'object' && typeof val === 'object') {
                    Object.assign(o[key], val);
                } else {
                    o[key] = val;
                }
            }
            return key in o ? o[key] : {};
        }, obj);
      },
      _convertNameToState: function(name) {
          return name.replace('_', '.').split('-').reduce(function(result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
          });
      },
      applySetting: function(setting, value) {
          var track = window.Quagga.CameraAccess.getActiveTrack();
          if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
              case 'zoom':
                  return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
              case 'torch':
                  return track.applyConstraints({advanced: [{torch: !!value}]});
              case 'focus':
                  return track.applyConstraints({advanced : [{focusMode: 'manual', focusDistance: value}]});
              }
          }
      },

      devicesChecked: [

      ],

      inputMapper: {
        inputStream: {
            constraints: function(value){
                if (/^(\d+)x(\d+)$/.test(value)) {
                    var values = value.split('x');
                    return {
                        width: {min: parseInt(values[0])},
                        height: {min: parseInt(values[1])}
                    };
                }
                return {
                    deviceId: value
                };
            }
        },
        numOfWorkers: function(value) {
            return parseInt(value);
        },
        decoder: {
            readers: function(value) {
                if (value === 'ean_extended') {
                    return [{
                        format: 'ean_reader',
                        config: {
                            supplements: [
                                'ean_5_reader', 'ean_2_reader'
                            ]
                        }
                    }];
                }
                return [{
                    format: value + '_reader',
                    config: {}
                }];
            }
        }
    },
      
    state: {
      inputStream: {
          name : 'Live',
          type : 'LiveStream',
          constraints: {
              width: {min: 640},
              height: {min: 480},
              aspectRatio: {min: 1, max: 100},
              facingMode: 'environment'
          }
      },
      locator: {
          patchSize: 'medium',
          halfSample: true
      },
      numOfWorkers: 4,
      frequency: 10,
      decoder: {
          readers : [{
              format: 'ean_reader',
              config: {}
          }]
      },
      locate: true
  },

      closeScanner: function () {
        var track = window.Quagga.CameraAccess.getActiveTrack();
        var capabilities = {};
        if (track && typeof track.getCapabilities === 'function') {
            capabilities = track.getCapabilities();
        }
        if (capabilities.torch) {
          this.setState('settings.torch', false);
          document.querySelector('input[name="settings_torch"]').checked = false;
        }
        this.detachListeners();
        this.turnOffCameraStream();
        window.Quagga.stop();
        $('body').removeClass('camera-active');
        this.$('#ean-scanner').addClass('is-hidden');
        this.$('.ean-scanner-settings').addClass('is-hidden');
      },

      remove: function () {
        _.each(this.subViews, function (view) {
          if (view && view.remove) {
            view.remove();
          }
        });
        this.$el.off();
        this.$el.empty();
        this.stopListening();
        return this;
      }
    })
    ;
  return View;
})
;

